import { Entity, JobTemplate, PartialJobCreateRequest } from '..';

export interface QuoteProConvertRequest {
    _id: string;
    convertType: QuoteConvertType;
    templateStage?: Entity;
    template?: JobTemplate;
    createRequest?: PartialJobCreateRequest;
    copyActivities: boolean;
}

export enum QuoteConvertType {
    JobTemplate = 'Job Template',
    ItemCategories = 'Item categories',
    QuoteSections = 'Quote sections',
    SingleStage = 'Single stage',
}